import React from 'react';
import { Outlet } from 'react-router-dom';  // Outlet is used to render nested routes

// Auth pages render their own full-screen layout
const AuthLayout = () => <Outlet />;

export default AuthLayout;
